<template>
  <van-overlay :show="visible" class="overlay">
    <div class="modal">
      <div class="process">
        <div class="item">
          <img src="@/assets/third/lucky/shopping.png" alt="" class="icon" />
          <div class="content">
            <div class="title">三年购下单，送抽奖券</div>
            <div class="desc">
              购买的商品在确认收货后，可根据订单金额获得抽奖券数张
            </div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/third/lucky/ticket.png" alt="" class="icon" />
          <div class="content">
            <div class="title">使用抽奖券，参与抽奖</div>
            <div class="desc">
              在活动页面，选择喜爱的奖项投入抽奖券，即为参与抽奖
            </div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/third/lucky/award.png" alt="" class="icon" />
          <div class="content">
            <div class="title">领取奖品</div>
            <div class="desc">中奖后，即可领取相应的奖品</div>
          </div>
        </div>
      </div>
      <div class="btns">
        <div class="cancel" @click="close">跳过</div>
        <div class="ok" @click="toLucky">去了解</div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      localStorage.setItem("thirdLuckyGuide", true); //抽奖引导
      this.$emit("visibleChange", false);
    },
    toLucky() {
      this.close();
      this.$router.push("/lucky");
    },
  },
};
</script>

<style lang="less" scoped>
.overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal {
  box-sizing: border-box;
  width: 28rem;
  height: 45.1rem;
  background-image: url(~@/assets/third/lucky/guide.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
  padding: 2.4rem 1.7rem;

  .process {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .item {
      flex: 1;
      display: flex;
      padding-bottom: 1.9rem;
      position: relative;

      &:not(:last-of-type)::before {
        content: " ";
        width: 0.1rem;
        height: 100%;
        position: absolute;
        left: 1.35rem;
        top: 2.2rem;
        background: #ffd6e3;
      }

      .icon {
        flex: 0 0 2.8rem;
        height: 2.8rem;
        margin-right: 0.9rem;
        position: relative;
      }

      .content {
        flex: 1;
        display: flex;
        flex-direction: column;

        .title {
          font-size: 1.6rem;
          color: #4a1500;
          font-weight: 700;
          line-height: 2.8rem;
        }

        .desc {
          font-size: 1.1rem;
          color: #885a47;
          margin-top: 0.4rem;
        }
      }
    }
  }

  .btns {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .cancel:extend(.btn) {
      width: 9.6rem;
      color: #fd386c;
      border: 0.1rem solid #fd3e73;
      background: linear-gradient(
        180deg,
        rgba(255, 171, 200, 0.1) 0%,
        rgba(255, 74, 130, 0.1) 15%,
        rgba(251, 37, 83, 0.1) 100%
      );
    }

    .ok:extend(.btn) {
      width: 14rem;
      color: #fff;
      border: 0.1rem solid #ffd9b7;
      background: linear-gradient(
        180deg,
        #ffabc8 0%,
        #ff4a82 15%,
        #fb2553 100%
      );
    }
  }
}

.btn {
  height: 3.6rem;
  border-radius: 1.8rem;
  font-size: 1.6rem;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
</style>
